// extracted by mini-css-extract-plugin
export default {"content_wrapper":"LibraryPage_content_wrapper__UA0F0","section_title":"LibraryPage_section_title__ganF4"};